import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'

export const tabsPartExClickEvent = (): TrackingEvent => ({
  eventName: 'home-page-tab-click',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'hp part ex',
      action: 'select',
      value: 'hp part ex tab',
      label: 'part ex generated',
    },
  },
})

export const tabsNewCarsClickEvent = (): TrackingEvent => ({
  eventName: 'Click on the New Cars tab on homepage hero',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'hero',
      action: 'select',
      value: 'new cars tab select',
      label: 'new cars',
    },
  },
})
